var $be5741ee9ed6adc7$exports = {};
$be5741ee9ed6adc7$exports = import.meta.resolve("2eofC");


const $35da740d59af89ba$var$SKYLER_PHOTO_URL = new URL($be5741ee9ed6adc7$exports).href;
var $e1b2e5dc67cdda47$exports = {};
$e1b2e5dc67cdda47$exports = import.meta.resolve("d35rL");


const $35da740d59af89ba$var$TRAVIS_PHOTO_URL = new URL($e1b2e5dc67cdda47$exports).href;
// handles keypresses for accessibility
function $35da740d59af89ba$var$handleClick(e) {
    if (e.type === 'keypress') {
        const code = e.keyCode;
        return code === 32 || code === 13;
    }
}
document.addEventListener('keypress', $35da740d59af89ba$var$handleClick);
const $35da740d59af89ba$var$hamburgerMenu = document.querySelector('.hamburger');
const $35da740d59af89ba$var$nav = document.querySelector('.nav');
let $35da740d59af89ba$var$menuOpen = false;
function $35da740d59af89ba$var$toggleMenu() {
    if (!$35da740d59af89ba$var$menuOpen) {
        $35da740d59af89ba$var$hamburgerMenu.classList.add('open');
        $35da740d59af89ba$var$nav.classList.add('visible');
        $35da740d59af89ba$var$menuOpen = true;
    } else {
        $35da740d59af89ba$var$hamburgerMenu.classList.remove('open');
        $35da740d59af89ba$var$nav.classList.remove('visible');
        $35da740d59af89ba$var$menuOpen = false;
    }
}
$35da740d59af89ba$var$hamburgerMenu.addEventListener('click', $35da740d59af89ba$var$toggleMenu);
let $35da740d59af89ba$var$currentProfile = document.querySelector('.profile--selected');
const $35da740d59af89ba$var$orgName = document.getElementById('about__name');
const $35da740d59af89ba$var$orgAbout = document.getElementById('about__desc');
const $35da740d59af89ba$var$orgPhoto = document.getElementById('about__photo');
const $35da740d59af89ba$var$orgProfiles = document.querySelectorAll('.profile');
for(let i = 0; i < $35da740d59af89ba$var$orgProfiles.length; i++){
    $35da740d59af89ba$var$orgProfiles[i].addEventListener('click', $35da740d59af89ba$var$selectProfile);
    $35da740d59af89ba$var$orgProfiles[i].addEventListener('keypress', (e)=>{
        if ($35da740d59af89ba$var$handleClick(e)) $35da740d59af89ba$var$selectProfile(e);
    });
}
function $35da740d59af89ba$var$selectProfile(e) {
    const currentProfileId = e.currentTarget.id;
    const selectedOrganizer = $35da740d59af89ba$var$organizers[currentProfileId];
    if (selectedOrganizer) {
        $35da740d59af89ba$var$currentProfile.classList.remove('profile--selected');
        $35da740d59af89ba$var$currentProfile = document.getElementById(`${currentProfileId}`);
        $35da740d59af89ba$var$currentProfile.classList.add('profile--selected');
        $35da740d59af89ba$var$orgName.textContent = selectedOrganizer.name;
        $35da740d59af89ba$var$orgAbout.textContent = selectedOrganizer.about;
        $35da740d59af89ba$var$orgPhoto.src = selectedOrganizer.profilePhoto;
        $35da740d59af89ba$var$orgPhoto.alt = `Kalispell Software Crafters organizer ${selectedOrganizer.name}`;
    }
}
const $35da740d59af89ba$var$organizers = {
    Travis: {
        name: 'Travis Craft',
        about: "I'm a Flathead native and remote software engineer. I want to connect with others to talk about software development and engineering. I first learned about software craftsmanship in the Fall of 2017 which led me to create this group. I've learned a lot along the way!",
        profilePhoto: $35da740d59af89ba$var$TRAVIS_PHOTO_URL
    },
    Skyler: {
        name: 'Skyler Bexten',
        about: 'Flathead native with computer science degree from UM. Fell in love with programming in a Java course. Likes JavaScript, test-driven development and plays with Haskell on the side. Reads too many books on the history of computer science and too much manga.',
        profilePhoto: $35da740d59af89ba$var$SKYLER_PHOTO_URL
    }
};


//# sourceMappingURL=kalispell-software-crafters.github.io.3ff29316.js.map
